module.exports = __webpack_public_path__ + "static/media/top-img_7-mob.13f628ce.jpg";